export enum UserRole {
    ADMIN = 'A',
    STUDENT = 'S',
    COURSE_REVIEWER = 'CR',
    WRITER = 'W',
    OTHERS = 'O'
}